import { render, staticRenderFns } from "./PageServices.vue?vue&type=template&id=5f2a4b26&scoped=true"
import script from "./PageServices.vue?vue&type=script&lang=js"
export * from "./PageServices.vue?vue&type=script&lang=js"
import style0 from "./PageServices.vue?vue&type=style&index=0&id=5f2a4b26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2a4b26",
  null
  
)

export default component.exports